// Float-RENDERABLE texture support, probed once per page.
//
// Shared by every GPU-simulation visualizer (Silk's Verlet cloth, Swarm's
// particles): they keep state in RGBA32F render targets, which needs more
// than float SAMPLING - the target has to be renderable. WebGL2 gates that
// behind EXT_color_buffer_float; WebGL1 behind OES_texture_float.
//
// Probed on a throwaway canvas at MODULE LOAD, not per instance:
// renderability is a property of the browser/GPU pair, not of a particular
// canvas, and the answer has to be available synchronously when a
// visualizer's PROFILE object is built (the registry reads `enabled` at
// import time). A visualizer with requiresFloatTextures simply never enters
// the rotation where support is missing - no runtime branch, nothing to
// crash.
function probe() {
  try {
    if (typeof document === 'undefined') return false;
    const cv = document.createElement('canvas');
    const gl2 = cv.getContext('webgl2');
    if (gl2) return !!gl2.getExtension('EXT_color_buffer_float');
    const gl1 = cv.getContext('webgl');
    return !!(gl1 && gl1.getExtension('OES_texture_float'));
  } catch (e) {
    return false;
  }
}

export const FLOAT_TEXTURES_OK = probe();
